import React from 'react';
import ChatHeader from './ChatHeader';
import ChatMenu from './ChatMenu';
import ChatMessagesView from './ChatMessagesView';
import ChatEmptyPresenter from './ChatEmptyPresenter';

import useStyles from './useStyles';
import useSubscribeChatRoom from './useSubscribeChatRoom';

import { useMediaQuery, useTheme } from '@material-ui/core';

const ChatPresenter = () => {
  const classes = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const { loading, error } = useSubscribeChatRoom();

  if (error) return <ChatEmptyPresenter />;

  if (loading) {
    return (
      <div className={classes['Chat-Container-root']}>
        {matches && <div className={classes['Chat-Menu-root']}></div>}

        <div className={classes['Chat-View-root']}></div>

        {!matches && <div className={classes['Chat-Menu-root']}></div>}
      </div>
    );
  }

  return (
    <div className={classes['Chat-Container-root']}>
      {matches && (
        <div className={classes['Chat-Menu-root']}>
          <ChatHeader matches={matches} />
          <ChatMenu.List matches={matches} />
        </div>
      )}
      <div className={classes['Chat-View-root']}>
        {!matches && <ChatHeader matches={matches} />}
        <ChatMessagesView matches={matches} />
      </div>

      {!matches && (
        <div className={classes['Chat-Menu-root']}>
          <ChatMenu.List matches={matches} />
        </div>
      )}
    </div>
  );
};

export default ChatPresenter;
